// useDebounce.js
import { useCallback, useRef } from "react";

function useDebounce(callback, delay) {
  const debounceTimeout = useRef(null);

  const debouncedCallback = useCallback((...args) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      callback(...args);
    }, delay);
  }, [callback, delay]);

  return debouncedCallback;
}

export default useDebounce;
